import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";  
import { axiosInstnace as axios } from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import moment from "moment";

const SplashScreen = (props) => {
  //Set the initial state
  const [masterSplashScreens, handleMasterSplashScreens] = useState([]);
  const [showCreateSplashScreen, handleShowCreateSplashScreen] = useState(false);
  const [createSplashTemplate, handleCreateSplashTemplate] = useState('template1');
  const [createSplashHeading, handleCreateSplashHeading] = useState('');
  const [createSplashDescription, handleCreateSplashDescription] = useState('');
  const [createSplashImage, handleCreateSplashImage] = useState(undefined);
  const [createSplashShowButton, handleCreateSplashShowButton] = useState(false);
  const [createSplashButtonText, handleCreateSplashButtonText] = useState('');
  const [createSplashAutoclose, handleCreateSplashAutoclose] = useState(false);
  const [createSplashAutocloseTimeout, handleCreateSplashAutocloseTimeout] = useState(0);
  const [createSplashScheduleStart, handleCreateSplashScheduleStart] = useState(undefined);
  const [createSplashScheduleEnd, handleCreateSplashScheduleEnd] = useState(undefined);

  const [showEditSplashScreen, handleShowEditSplashScreen] = useState(false);
  const [editSplashId, handleEditSplashId] = useState(undefined);
  const [editSplashTemplate, handleEditSplashTemplate] = useState('template1');
  const [editSplashHeading, handleEditSplashHeading] = useState('');
  const [editSplashDescription, handleEditSplashDescription] = useState('');
  const [editSplashImage, handleEditSplashImage] = useState(undefined);
  const [editSplashShowButton, handleEditSplashShowButton] = useState(false);
  const [editSplashButtonText, handleEditSplashButtonText] = useState('');
  const [editSplashAutoclose, handleEditSplashAutoclose] = useState(false);
  const [editSplashAutocloseTimeout, handleEditSplashAutocloseTimeout] = useState(0);
  const [editSplashScheduleStart, handleEditSplashScheduleStart] = useState(undefined);
  const [editSplashScheduleEnd, handleEditSplashScheduleEnd] = useState(undefined);

  const [showPreviewSplash, handleShowPreviewSplash] = useState(false);
  const [previewSplashContent, handlePreviewSplashContent] = useState(undefined);
  
  
  useEffect(() => {
    getScreens();
  }, []);


  const goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  const getScreens = async () => {
    try {
      const splashScreensResponse = await axios.get(endPoints.getAllSplashScreens);
      if(splashScreensResponse.data && splashScreensResponse.data.data.data.screens){
        handleMasterSplashScreens(splashScreensResponse.data.data.data.screens);
        resetCreateSplashScreen();
      }
    } catch (error) {
        handleMasterSplashScreens([]);
    }
  }
  
  const createSplashScreen = (e) => {
    handleShowCreateSplashScreen(!showCreateSplashScreen);
  }

  const submitCreateSplashScreen = async (e) => {
    try {
    
        if(!createSplashTemplate || !createSplashHeading || !createSplashDescription || !createSplashImage || !createSplashScheduleStart || !createSplashScheduleEnd){
            toast.warn("Please fill all fields and try to submit again", {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: false,
                toastId: "1",
            });

            return false;
        }
        
        let formData = new FormData();
        formData.append("template", createSplashTemplate);
        formData.append("heading", createSplashHeading);
        formData.append("description", createSplashDescription);
        formData.append("splashimage", createSplashImage);
        formData.append("showbutton", createSplashShowButton);
        formData.append("buttontext", createSplashButtonText);
        formData.append("autoclose", createSplashAutoclose);
        formData.append("autoclosetimeout", createSplashAutocloseTimeout);
        formData.append("schedulestart", createSplashScheduleStart);
        formData.append("scheduleend", createSplashScheduleEnd);

        const createSplashResponse = await axios.post(endPoints.createSplashScreen, formData);

      if(createSplashResponse.data && createSplashResponse.data){
        handleShowCreateSplashScreen(false);
        getScreens();

        toast.success("New splash screen created", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: false,
            toastId: "1",
        });
      }  
    } catch (error) {
        handleShowCreateSplashScreen(false);
        toast.error("Error occurred while creating new splash screen", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: false,
            toastId: "1",
        });
    }
  }

  const cancelCreateSplashScreen = (e) => {
    handleShowCreateSplashScreen(false);
  }

  const cancelEditSplashScreen = (e) => {
    handleShowEditSplashScreen(false);
  }

  const resetCreateSplashScreen = () => {
    handleCreateSplashTemplate('template1');
    handleCreateSplashHeading('');
    handleCreateSplashDescription('');
    handleCreateSplashImage('');
    handleCreateSplashShowButton(false);
    handleCreateSplashButtonText('');
    handleCreateSplashAutoclose(false);
    handleCreateSplashAutocloseTimeout(0);
    handleCreateSplashScheduleStart('');
    handleCreateSplashScheduleEnd('');
  }
  
  const resetEditSplashScreen = () => {
    handleEditSplashId(undefined);
    handleEditSplashTemplate('template1');
    handleEditSplashHeading('');
    handleEditSplashDescription('');
    handleEditSplashImage('');
    handleEditSplashShowButton(false);
    handleEditSplashButtonText('');
    handleEditSplashAutoclose(false);
    handleEditSplashAutocloseTimeout(0);
    handleEditSplashScheduleStart('');
    handleEditSplashScheduleEnd('');
  }
  
  const updateSplashScreen = async (e) => {
    try {
    
        if(!editSplashTemplate || !editSplashHeading || !editSplashDescription || !editSplashScheduleStart || !editSplashScheduleEnd){
            toast.warn("Please fill all fields and try to submit again", {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: false,
                toastId: "1",
            });

            return false;
        }
        
        let formData = new FormData();
        formData.append("id", editSplashId);
        formData.append("template", editSplashTemplate);
        formData.append("heading", editSplashHeading);
        formData.append("description", editSplashDescription);
        formData.append("showbutton", editSplashShowButton);
        formData.append("buttontext", editSplashButtonText);
        formData.append("autoclose", editSplashAutoclose);
        formData.append("autoclosetimeout", editSplashAutocloseTimeout);
        formData.append("schedulestart", editSplashScheduleStart);
        formData.append("scheduleend", editSplashScheduleEnd);

        if(editSplashImage){
          formData.append("splashimage", editSplashImage);
        }

        const updatedSplashResponse = await axios.post(endPoints.updateSplashScreen, formData);

      if(updatedSplashResponse.data && updatedSplashResponse.data){
        handleShowEditSplashScreen(false);
        resetEditSplashScreen();

        getScreens();

        toast.success("Splash screen updated", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: false,
            toastId: "1",
        });
      }  
    } catch (error) {
        handleShowCreateSplashScreen(false);
        toast.error("Error occurred while updating splash screen", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: false,
            toastId: "1",
        });
    }
  }

  const editSplashScreen = (splashScreen) => {
    handleEditSplashId(splashScreen._id);
    handleEditSplashTemplate(splashScreen.template)
    handleEditSplashHeading(splashScreen.heading)
    handleEditSplashDescription(splashScreen.description)
    handleEditSplashShowButton(splashScreen.showbutton)
    handleEditSplashButtonText(splashScreen.buttontext)
    handleEditSplashAutoclose(splashScreen.autoclose)
    handleEditSplashAutocloseTimeout(splashScreen.autoclosetimeout)
    handleEditSplashScheduleStart(moment(splashScreen.schedulestart).format('YYYY-MM-DD'))
    handleEditSplashScheduleEnd(moment(splashScreen.scheduleend).format('YYYY-MM-DD'))

    handleShowCreateSplashScreen(false);
    handleShowEditSplashScreen(true);
  }

  const uploadedImage = (e, currentTemplate, handler) => {
    let _URL = window.URL || window.webkitURL;
    let file, img;

    if ((file = e.target.files[0])) {
        img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if(currentTemplate == 'template1' && this.height < this.width){
            toast.warn("Template 1 supports only portrait image", {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: false,
              toastId: "1",
            });
          }else if(currentTemplate == 'template2' && this.height > this.width){
            toast.warn("Template 2 supports only landscape image", {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: false,
              toastId: "1",
            });
          }else{
            handler(file);
          }
        };
        img.src = objectUrl;
    }
  }

  const previewSplash = ()=>{
    if(!createSplashImage){
      toast.warn("Please provide image and preview again", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: false,
          toastId: "1",
      });
      return false;
    }

    let splashData = {
      template: createSplashTemplate,
      heading: createSplashHeading,
      description: createSplashDescription,
      showbutton: createSplashShowButton,
      buttontext: createSplashButtonText,
      splashImage: URL.createObjectURL(createSplashImage)
    };

    handleShowPreviewSplash(true);
    handlePreviewSplashContent(splashData);
  }

  return (
    <div className="dashboardContainer">
       <HeaderAdminpanel/>

      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar role={localStorage.getItem("adminRole")} />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Homepage |<span className="breadcrumb-active fct-breadcrumb">Splash Screen Management</span>
            </div>

            <div className="print_btn">
              <button onClick={createSplashScreen}> Create Splash screen </button>{" "}
            </div>{" "}
          </div>
          <div className="dashboard-content userListing-dashboard bg-white table-responsive">
            { showCreateSplashScreen && (
              <div>
                <h3 style={{marginBottom: '10px'}}>Create Splash screen</h3>
                <table style={{ width: "50%", borderCollapse: "separate", borderSpacing: "0 1em" }}>
                  <tr>
                    <td>
                      <label htmlFor="template">Template</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        <select className="packageType drop-down-icon status-dropdown" id="template" defaultValue="template1" onChange={ (e)=>{
                            e.target.value == 'template1' ? handleCreateSplashTemplate ('template1') : handleCreateSplashTemplate('template2');
                        } }>
                            <option value="template1" selected>Template 1 - Portrait Image</option>
                            <option value="template2">Template 2 - Landscape Image</option>
                        </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="heading">Heading</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <input type="text" id="heading" value={ createSplashHeading } defaultValue="" onChange={ (e)=> handleCreateSplashHeading(e.target.value) } />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="description">Description</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <textarea id="description" onChange={ (e)=> handleCreateSplashDescription(e.target.value) } style={{ padding: "5px 5px 5px 25px", borderColor: "#cccc", width: "100%"}} >{ createSplashDescription }</textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="image">Image</label>
                    </td>
                    <td>
                        <input id="image" accept="image/*" type="file" onChange={(e)=>{
                          uploadedImage(e, createSplashTemplate, handleCreateSplashImage);
                        }}  />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="showbutton">Show Action Button</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        <select className="packageType drop-down-icon status-dropdown" id="showbutton" onChange={ (e)=>{
                            e.target.value == 'true' ? handleCreateSplashShowButton(true) : handleCreateSplashShowButton(false);
                        } }>
                            <option value="true">Yes</option>
                            <option value="false" selected>No</option>
                        </select>
                    </td>
                  </tr>
                  { createSplashShowButton && (<tr>
                    <td>
                      <label htmlFor="buttontext">Action button text</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <input type="text" id="buttontext" onChange={ (e)=> handleCreateSplashButtonText(e.target.value) } />
                    </td>
                  </tr>)}
                  <tr>
                    <td>
                      <label htmlFor="autoclose">Automatically close</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        <select className="packageType drop-down-icon status-dropdown" id="autoclose" onChange={ (e)=>{
                            e.target.value == 'true' ? handleCreateSplashAutoclose (true) : handleCreateSplashAutoclose(false);
                        } }>
                            <option value="true">Yes</option>
                            <option value="false" selected>No</option>
                        </select>
                    </td>
                  </tr>
                  { createSplashAutoclose && (<tr>
                    <td>
                      <label htmlFor="autoclosetimeout">Auto close timeout</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <input type="text" id="autoclosetimeout" onChange={ (e)=> handleCreateSplashAutocloseTimeout(e.target.value) } />
                    </td>
                  </tr>)}
                  <tr>
                    <td>
                      <label htmlFor="schedule">Schedule</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        From <input style={{ width: "220px !important" }} onChange={ (e)=> handleCreateSplashScheduleStart(e.target.value) } type="date" /> to   <input style={{ width: "220px !important" }} onChange={ (e)=> handleCreateSplashScheduleEnd(e.target.value) } type="date" />
                    </td>
                  </tr>
                </table>
                <div style={{ marginTop: "20px"}} className="search_camp search_list">
                  <button onClick={submitCreateSplashScreen} style={{ color: "white", padding: "10px" }}>Submit</button>
                  <button onClick={previewSplash} style={{ background: "silver", color: "white", padding: "10px" }}>Preview</button>
                  <button onClick={cancelCreateSplashScreen} style={{ background: "silver", padding: "10px" }}>Cancel</button>
                </div>
              </div>
            )}

            { showEditSplashScreen && (
              <div style={{ padding: "10px" }}>
                <h3 style={{marginBottom: '10px'}}>Edit Splash screen</h3>
                <table style={{ width: "50%", borderCollapse: "separate", borderSpacing: "0 1em" }}>
                  <tr>
                    <td>
                      <label htmlFor="template">Template</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        <select className="packageType drop-down-icon status-dropdown" id="template" defaultValue="template1" onChange={ (e)=>{
                            e.target.value == 'template1' ? handleEditSplashTemplate ('template1') : handleEditSplashTemplate('template2');
                        } } value={ editSplashTemplate }>
                            <option value="template1">Template 1 - Portrait Image</option>
                            <option value="template2">Template 2 - Landscape Image</option>
                        </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="heading">Heading</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <input type="text" id="heading" value={ createSplashHeading } defaultValue="" onChange={ (e)=> handleEditSplashHeading(e.target.value) }  value={ editSplashHeading } />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="description">Description</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <textarea id="description" onChange={ (e)=> handleEditSplashDescription(e.target.value) } style={{ padding: "5px 5px 5px 25px", borderColor: "#cccc", width: "100%"}} >{ editSplashDescription }</textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="image">Image</label>
                    </td>
                    <td>
                        <input id="image" accept="image/*" type="file" onChange={(e)=>{
                          uploadedImage(e, editSplashTemplate, handleEditSplashImage);
                        }}  />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label htmlFor="showbutton">Show Action Button</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        <select className="packageType drop-down-icon status-dropdown" id="showbutton" onChange={ (e)=>{
                            e.target.value == 'true' ? handleEditSplashShowButton(true) : handleEditSplashShowButton(false);
                        } }  value={ editSplashShowButton }>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </td>
                  </tr>
                  { editSplashShowButton && (<tr>
                    <td>
                      <label htmlFor="buttontext">Action button text</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <input type="text" id="buttontext" onChange={ (e)=> handleEditSplashButtonText(e.target.value) } value={ editSplashButtonText } />
                    </td>
                  </tr>)}
                  <tr>
                    <td>
                      <label htmlFor="autoclose">Automatically close</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        <select className="packageType drop-down-icon status-dropdown" id="autoclose" onChange={ (e)=>{
                            e.target.value == 'true' ? handleEditSplashAutoclose (true) : handleEditSplashAutoclose(false);
                        } } value={ editSplashAutoclose }>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </td>
                  </tr>
                  { editSplashAutoclose && (<tr>
                    <td>
                      <label htmlFor="autoclosetimeout">Auto close timeout</label>
                    </td>
                    <td className="status-input search_camp search_list">
                      <input type="text" id="autoclosetimeout" onChange={ (e)=> handleEditSplashAutocloseTimeout(e.target.value) } value={ editSplashAutocloseTimeout } />
                    </td>
                  </tr>)}
                  <tr>
                    <td>
                      <label htmlFor="schedule">Schedule</label>
                    </td>
                    <td className="status-input search_camp search_list">
                        From <input style={{ width: "220px !important" }} onChange={ (e)=> handleEditSplashScheduleStart(e.target.value) } type="date"  value={ editSplashScheduleStart } /> to   <input style={{ width: "220px !important" }} onChange={ (e)=> handleEditSplashScheduleEnd(e.target.value) } type="date"  value={ editSplashScheduleEnd } />
                    </td>
                  </tr>
                </table>
                <div style={{ marginTop: "20px"}} className="search_camp search_list">
                  <button onClick={updateSplashScreen} style={{ color: "white", padding: "10px" }}>Submit</button>
                  <button onClick={cancelEditSplashScreen} style={{ background: "silver", padding: "10px" }}>Cancel</button>
                </div>
              </div>
            )}
            
            <table className="table table-striped master-table">
              <thead>
                <tr>
                  <th>Heading</th>
                  <th>Description</th>
                  <th>Template</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                { masterSplashScreens && masterSplashScreens.map( (masterSplashScreen, masterSplashScreenKey) =>(
                  <tr key={masterSplashScreenKey}>
                    <td>{masterSplashScreen.heading}</td>
                    <td>{masterSplashScreen.description}</td>
                    <td>{masterSplashScreen.template}</td>
                    <td>{moment(masterSplashScreen.schedulestart).format('DD-MM-YYYY')}</td>
                    <td>{moment(masterSplashScreen.scheduleend).format('DD-MM-YYYY')}</td>
                    <td> <button style={{ color: "white" }} onClick={ (e) => editSplashScreen(masterSplashScreen) }>Edit</button> </td>
                  </tr>
                ) ) }
                
              </tbody>
            </table>
          </div>
          
          { showPreviewSplash && previewSplashContent && (
            <div id="splash_screen_wrapper">
              <div className="splash_screen_container">
                <span className="close_btn" onClick={ ()=> { handleShowPreviewSplash(false) } }>x</span>
                <div className={"splash_screen "}>
                  { previewSplashContent.template == 'template1' && (
                    <div className="template_1">
                      <div className="leftside">
                        <img src={ previewSplashContent.splashImage } alt={ previewSplashContent.heading } />
                      </div>
                      <div className="rightside">
                        <h2>{ previewSplashContent.heading }</h2>
                        <p>{ previewSplashContent.description }</p>

                        { previewSplashContent.showbutton && (
                          <div className="button_container">
                            <a href={ `/contact?splashid` } className="button">{ previewSplashContent.buttontext }</a>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  { previewSplashContent.template == 'template2' && (
                    <div className="template_2">
                      <div className="center">
                        <img src={ previewSplashContent.splashImage } alt={ previewSplashContent.heading } />

                        <div className="content_container">
                          <h2>{ previewSplashContent.heading }</h2>
                          <p>{ previewSplashContent.description }</p>

                          { previewSplashContent.showbutton && (
                            <div className="button_container">
                              <a href={ `/contact?splashid` } className="button">{ previewSplashContent.buttontext }</a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>  
                  )}
                  
                  
                </div>
              </div>
            </div>
          )}

          <ToastContainer />
        </section>
      </div>
    </div>
  );
};

export default connect(null, {})(SplashScreen);



// WEBPACK FOOTER //
// ./web/components/admin/home/splashscreen.js